import {z} from "zod";

export const customerSearchFormSchema = z.object({
	representativeName: z.string().optional()
});

export type CustomerSearchFormType = z.infer<typeof customerSearchFormSchema>;
